export const uk = {
    'error-message': 'Не удалось выполнить запрос, попробуйте позже.',
    'failed-to-delete-comment-message':
        'Не удалось удалить данный комментарий. Попробуйте обновить страницу и попробовать еще раз',
    'success-message':
        'Спасибо, что поделились обратной связью о работе со специалистом! Мы отправили ваш отзыв на модерацию, после этого он может быть опубликован на странице специалиста и учтён в расчёте его рейтинга.'
};
